import { z } from 'zod';
import { refreshUserScoreOutputSchema, refreshUserScoreQuerySchema } from '@zealy/schemas';
import { mutation } from '../../utils';
export const refreshUserScore = mutation({
    method: 'POST',
    path: '/:tradingCompetitionId/refresh-user-score',
    query: refreshUserScoreQuerySchema,
    body: z.object({}), // Empty body for this endpoint
    responses: {
        200: refreshUserScoreOutputSchema,
    },
});
